import { createContext, useContext, useState } from "react";

export const KeywordValueContext = createContext()

export const useSearch = () => useContext(KeywordValueContext)

export const SearchProvider = ({children}) => {
    const [keyword, setKeyword] = useState('');
    const [customer, setCustomer] = useState('');

    const updateKeyword = (keywordValue) => {
        setKeyword(keywordValue)
    }

    const updateCustomer = (customerValue) => {
        setCustomer(customerValue);
    };

    return (
        <KeywordValueContext.Provider value={{
            keyword,
            updateKeyword,
            setKeyword,
            customer,      
            updateCustomer 
        }}>
            {children}
        </KeywordValueContext.Provider>
    )
}